import { Routes } from '@angular/router';
import { LocationPopupComponent } from './location.component';

export const BREEDING_LOCATION_ROUTES: Routes = [
    {
        path: 'location/:locationId',
        component: LocationPopupComponent,
        outlet: 'popup'
    }
];
